import { FC } from 'react';
import CreateTag from 'containers/tags/create-tag/CreateTag';

const EditTagPage: FC = () => {
  return <CreateTag isEdit={true} />;
};

export default EditTagPage;
